export default {"src":"/login-app/[GIT_HASH]/_next/static/media/copy_to_clipboard_done.f1a4d1b3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};